import React from "react"
import {
  CartItemContainer,
  CartItemWrapper,
  ImgWrap,
  Img,
  CakeContent,
  CakeTitle,
  CakeP,
  RemoveIcon,
  Icon,
} from "./CartItemElements"
import { connect } from "react-redux"
import { clearItemFromCart } from "../../redux/cart/cart.actions"

const CartItem = ({ item, clearItemFromCart }) => {
  const { image, name } = item.cake
  const {
    cakePrice,
    quantity,
    addonAccessories,
    selectDebossingTag,
    selectEmbossingTag,
    selectLuggageTag,
    selectRibbonTag,
    selectMiniTopper,
    selectTopper,
    isGiftCard,
  } = item

  return (
    <>
      <CartItemContainer>
        <CartItemWrapper>
          <ImgWrap>
            <Img src={image} alt="item" />
          </ImgWrap>
          <CakeContent>
            <CakeTitle>{name}</CakeTitle>
            <CakeP>
              {quantity} x RM {cakePrice}
            </CakeP>
            {selectDebossingTag ? <CakeP>Tag: RM {addonAccessories.price}</CakeP> : null}
            {selectEmbossingTag ? <CakeP>Tag: RM {addonAccessories.price}</CakeP> : null}
            {selectLuggageTag ? <CakeP>Tag: RM {addonAccessories.price}</CakeP> : null}
            {selectRibbonTag ? <CakeP>Tag: RM {addonAccessories.price}</CakeP> : null}
            {selectMiniTopper ? <CakeP>Topper: RM {addonAccessories.price}</CakeP> : null}
            {selectTopper ? <CakeP>Topper: RM {addonAccessories.price}</CakeP> : null}
            {isGiftCard ? <CakeP>Gift Card: RM 8</CakeP> : null}
          </CakeContent>
          <Icon>
            <RemoveIcon onClick={() => clearItemFromCart(item)} />
          </Icon>
        </CartItemWrapper>
      </CartItemContainer>
    </>
  )
}

const mapDispatchToProps = (dispatch) => ({
  clearItemFromCart: (item) => dispatch(clearItemFromCart(item)),
})

export default connect(null, mapDispatchToProps)(CartItem)
